// Top-players payload schema (`ItemsData<Player>`).

import { playerSchema, itemsDataSchema } from './common';

export const topPlayersSchema = itemsDataSchema(playerSchema);
